import CookieService from '@/services/cookies';
import { FC, useEffect } from 'react';
import JoinClassView from './joinClass.view';
import LoginView from './login.view';

type Props = {
	containerIp: string | null;
};
const LoginContainer: FC<Props> = ({ containerIp }: Props) => {
	const user = localStorage.getItem('user');
	const userToken = CookieService.get('access_token');

	// /dashboard is the universal destination of the session pages' kick-out
	// (getServerSideProps redirects here when access_token is missing/expired or
	// access is denied). A session that ended without a clean logout — tab closed,
	// token expired — leaves the Vonage SDK's persistent `opentok_client_id` in
	// localStorage. Reusing that stale client identity on the next
	// `session.connect()` keeps the OpenTok session/publisher from coming up, so
	// the user is stuck "connecting" until a manual logout (today the only path
	// that clears it). Clearing it here — at the login screen mount, covering both
	// the LoginView and "welcome back" JoinClassView branches below — guarantees
	// the next class entry gets a fresh OT client identity. Safe because reaching
	// /dashboard means any prior OT session is already over; legitimate in-class
	// refreshes don't pass through here, so OpenTok's own reconnection id survives.
	useEffect(() => {
		localStorage.removeItem('opentok_client_id');
	}, []);

	if (!user || !userToken) {
		return <LoginView containerIp={containerIp} />;
	}

	return <JoinClassView />;
};
export default LoginContainer;
